import React from 'react'
import { Auth, CommentLength, Redirect, T, jsonwebtoken, post } from '../Atom/Atom';
import { useRecoilState, useRecoilValue } from 'recoil';
import { useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import axios from '../axios/Axios';
import { toast } from 'react-toastify';

export const EditComment = ({c}) => {
    const [id, setId] = useRecoilState(post);
  const [user, setUser] = useRecoilState(Auth);
  const jwt = useRecoilValue(jsonwebtoken);
  const [mycomment, setMycomment] = useState([]);
  const [comments, setComments] = useState([]);
  const [content, setContent] = useState("");
  const navigate = useNavigate();
  const [redirect, setRedirect] = useRecoilState(Redirect);
  const [edit, setEdit] = useState(false);
  const [t, setT] = useRecoilState(T);
  const [contents, setContents] = useState();
  const[l,setL]=useRecoilState(CommentLength)
  const location = useLocation();
  const handleDelete = (e, id) => {
    e.preventDefault();
    axios
      .post("/deletecomment", {
        commentId: id,
      })
      .then((result) => {
        if (result.data.status) {
          toast.success("Comment Delete Successfully");
          setT((prev) => prev + 1);
        }
      })
      .catch((err) => console.log(err));
  };
  const handleEdit = (e, id) => {
    e.preventDefault();
    axios
      .post("/editcomment", {
        commentId: id,
        content: contents,
      })
      .then((result) => {
        if (result.data.status) {
          toast.success("Comment Edited Successfully");
          setT((prev) => prev + 1);
          setEdit(!edit)
        }
      })
      .catch((err) => console.log(err));
  };
  return (
    <div>
         <div className="comment-container">
          <p className="user-name">
            {c.username}
            {"  "}
            <l className="date">
              {" "}
              {new Date(c.created_at).toLocaleDateString("en-US", {
                year: "numeric",
                month: "long",
                day: "numeric",
              })}
              {"  "}
              {c.Edited == 1 ? "Edited" : null}
            </l>
          </p>
          <k className="comment"> {c.content} </k>
          <div
            className="d-flex justify-content-left gap-4"
            style={{ marginLeft: "2em", marginTop: "1em" }}
          >
            {edit ? (
              <>
                <textarea
                  className="form-control"
                  type="text"
                  value={contents}
                  onChange={(e) => setContents(e.target.value)}
                />
                <button
                  onClick={(e) => handleEdit(e, c.comment_id)}
                  className="btn btn-outline-secondary"
                  disabled={contents.length < 2 || contents == c.content}
                >
                  Save
                </button>
              </>
            ) : null}
            <button
              className="btn btn-info"
              onClick={(e) => {
                setEdit((prev) => !prev);
                setContents(c.content);
              }}
            >
              {!edit ? "Edit" : "Cancel"}
            </button>
            {!edit ? (
              <button
                className="btn btn-danger"
                onClick={(e) => handleDelete(e, c.comment_id)}
              >
                Delete
              </button>
            ) : null}
          </div>
          <hr />
        </div>
        
    </div>
  )
}
